import {UmpireIncident} from '../umpire-incident';
import {UmpireSquad} from '../umpire-squad';

export interface UmpireMatchEvent {
  type: string;

  id: string;

  start_time: string | undefined;

  home_squad: UmpireSquad;

  away_squad: UmpireSquad;

  incidents: UmpireIncident[];
}
